<template>
  <!-- Bar Chart Types -->
  <div v-if="graph_clone">
    <div
      v-if="
        graph_clone.graph_type === 'horizontal_bars' ||
          graph_clone.graph_type === 'vertical_bars' ||
          graph_clone.graph_type === 'stacked_horizontal_bars' ||
          graph_clone.graph_type === 'stacked_vertical_bars'
      "
      class="h-full">
      <Card
        :data-source="dataSource"
        :graph="graph_clone"
        :page-reference="pageReference"
        :name="graph_clone.name"
        v-bind="common_chart_props">
        <template v-if="graph_data.length >= 1" #checkbox>
          <div class="flex justify-between mt-2 ml-6">
            <input
              v-model="checked"
              :style="{ backgroundColor: backgroundColor }"
              type="checkbox"
              class="form-checkbox text-light-brand-blue dark:text-dark-brand-blue checked:bg-light-brand-blue dark:checked:bg-dark-brand-blue bg-light-box-background dark:bg-dark-box-background border-[2px] focus:ring-0 ring-dark/0 border-common-grey w-5 rounded h-5 transition ease-in-out duration-side-menu-transition-duration">
            <div class="text-[13px] ml-4 pb-4 text-light-body-text dark:text-dark-body-text">
              {{ $t("Toggle Legend") }}
            </div>
          </div>
        </template>
        <BarChart
          v-if="graph_data.length >= 1"
          :height="itemLayoutHeight / 6"
          :chartid="chartId"
          :is-horizontal="graph_clone.graph_type == 'horizontal_bars' || graph_clone.graph_type == 'stacked_horizontal_bars'"
          :chartdata="graph_data"
          :labels="graph_labels"
          v-bind="common_chart_props" />
        <div v-else class="pl-4 flex items-center justify-center min-h-[300px] dark:text-dark-body-text">
          {{ $t("No data to display") }}
        </div>
      </Card>
    </div>

    <!-- 100% Stacked Bar Chart Types -->
    <div v-else-if="graph_clone.graph_type === '100_stacked_bars'" class="h-full">
      <Card
        :data-source="dataSource"
        :graph="graph_clone"
        :page-reference="pageReference"
        :name="graph_clone.name"
        v-bind="common_chart_props">
        <template v-if="graph_data.length >= 1" #checkbox>
          <div class="flex justify-between mt-2 ml-6">
            <input
              v-model="checked"
              :style="{ backgroundColor: backgroundColor }"
              type="checkbox"
              class="form-checkbox text-light-brand-blue dark:text-dark-brand-blue checked:bg-light-brand-blue dark:checked:bg-dark-brand-blue bg-light-box-background dark:bg-dark-box-background border-[2px] focus:ring-0 ring-dark/0 border-common-grey w-5 rounded h-5 transition ease-in-out duration-side-menu-transition-duration">
            <div class="text-[13px] ml-4 pb-4 text-light-body-text dark:text-dark-body-text">
              {{ $t("Toggle Legend") }}
            </div>
          </div>
        </template>
        <StackedChart
          v-if="graph_data.length >= 1"
          :height="itemLayoutHeight / 6"
          :chartid="chartId"
          :chartdata="graph_data"
          :labels="graph_labels"
          v-bind="common_chart_props" />
        <div v-else class="pl-4 flex items-center justify-center min-h-[300px] dark:text-dark-body-text">
          {{ $t("No data to display") }}
        </div>
      </Card>
    </div>

    <!-- Patterned Bars Bar Chart Types -->
    <div v-else-if="graph_clone.graph_type === 'patterned_bars'" class="h-full">
      <Card
        :data-source="dataSource"
        :graph="graph_clone"
        :page-reference="pageReference"
        :name="graph_clone.name"
        v-bind="common_chart_props">
        <template v-if="graph_data.length >= 1" #checkbox>
          <div class="flex justify-between mt-2 ml-6">
            <input
              v-model="checked"
              :style="{ backgroundColor: backgroundColor }"
              type="checkbox"
              class="form-checkbox text-light-brand-blue dark:text-dark-brand-blue checked:bg-light-brand-blue dark:checked:bg-dark-brand-blue bg-light-box-background dark:bg-dark-box-background border-[2px] focus:ring-0 ring-dark/0 border-common-grey w-5 rounded h-5 transition ease-in-out duration-side-menu-transition-duration">
            <div class="text-[13px] ml-4 pb-4 text-light-body-text dark:text-dark-body-text">
              {{ $t("Toggle Legend") }}
            </div>
          </div>
        </template>
        <PatternedChart
          v-if="graph_data.length >= 1"
          :height="itemLayoutHeight / 6"
          :chartid="chartId"
          :chartdata="graph_data"
          :labels="graph_labels"
          v-bind="common_chart_props" />
        <div v-else class="pl-4 flex items-center justify-center min-h-[300px] dark:text-dark-body-text">
          {{ $t("No data to display") }}
        </div>
      </Card>
    </div>

    <!-- Table Chart Type -->
    <div v-else-if="graph_clone.graph_type === 'table'" class="h-full">
      <Card
        :data-source="dataSource"
        :graph="graph_clone"
        :page-reference="pageReference"
        :name="graph_clone.name"
        v-bind="common_chart_props">
        <template v-if="graph_data.length >= 1" #checkbox>
          <div class="flex justify-between mt-2 ml-6">
            <input
              v-model="checked"
              type="checkbox"
              class="form-checkbox text-light-brand-blue dark:text-dark-brand-blue checked:bg-light-brand-blue dark:checked:bg-dark-brand-blue bg-light-box-background dark:bg-dark-box-background border-[2px] focus:ring-0 ring-dark/0 border-common-grey w-5 rounded h-5 transition ease-in-out duration-side-menu-transition-duration">
            <div class="text-[13px] ml-4 pb-4 text-light-body-text dark:text-dark-body-text">
              {{ $t("Toggle Legend") }}
            </div>
          </div>
        </template>

        <TableChart v-if="graph_data.length >= 1" :graph="graph_clone" :chartdata="graph_data" v-bind="common_chart_props" />
        <div v-else class="pl-4 flex items-center justify-center min-h-[300px] dark:text-dark-body-text">
          {{ $t("No data to display") }}
        </div>
      </Card>
    </div>

    <!-- Pie Chart Type -->
    <div v-else-if="graph_clone.graph_type === 'pie'" class="h-full">
      <Card
        :data-source="dataSource"
        :graph="graph_clone"
        :page-reference="pageReference"
        :name="graph_clone.name"
        v-bind="common_chart_props">
        <template v-if="graph_data.length >= 1" #checkbox>
          <div class="flex justify-between mt-2 ml-6">
            <input
              v-model="checked"
              type="checkbox"
              class="form-checkbox text-light-brand-blue dark:text-dark-brand-blue checked:bg-light-brand-blue dark:checked:bg-dark-brand-blue bg-light-box-background dark:bg-dark-box-background border-[2px] focus:ring-0 ring-dark/0 border-common-grey w-5 rounded h-5 transition ease-in-out duration-side-menu-transition-duration">
            <div class="text-[13px] ml-4 pb-4 text-light-body-text dark:text-dark-body-text">
              {{ $t("Toggle Legend") }}
            </div>
          </div>
        </template>

        <PieChart
          v-if="graph_data.length >= 1"
          :chartid="chartId"
          :chartdata="graph_data"
          :colors="graph_series_color"
          :labels="graph_labels"
          :height="itemLayoutHeight"
          v-bind="common_chart_props" />
        <div v-else class="pl-4 flex items-center justify-center min-h-[300px] dark:text-dark-body-text">
          {{ $t("No data to display") }}
        </div>
      </Card>
    </div>

    <!-- Donut Chart Type -->
    <div v-else-if="graph_clone.graph_type === 'donut_chart'" class="h-full">
      <Card
        :data-source="dataSource"
        :graph="graph_clone"
        :page-reference="pageReference"
        :name="graph_clone.name"
        v-bind="common_chart_props">
        <template v-if="graph_data.length >= 1" #checkbox>
          <div class="flex justify-between mt-2 ml-6">
            <input
              v-model="checked"
              type="checkbox"
              class="form-checkbox text-light-brand-blue dark:text-dark-brand-blue checked:bg-light-brand-blue dark:checked:bg-dark-brand-blue bg-light-box-background dark:bg-dark-box-background border-[2px] focus:ring-0 ring-dark/0 border-common-grey w-5 rounded h-5 transition ease-in-out duration-side-menu-transition-duration">
            <div class="text-[13px] ml-4 pb-4 text-light-body-text dark:text-dark-body-text">
              {{ $t("Toggle Legend") }}
            </div>
          </div>
        </template>

        <DonutChart
          v-if="graph_data.length >= 1"
          :chartid="chartId"
          :chartdata="graph_data"
          :colors="graph_series_color"
          :labels="graph_labels"
          :height="itemLayoutHeight"
          v-bind="common_chart_props" />
        <div v-else class="pl-4 flex items-center justify-center min-h-[300px] dark:text-dark-body-text">
          {{ $t("No data to display") }}
        </div>
      </Card>
    </div>

    <!-- Area Chart Type -->
    <div v-else-if="graph_clone.graph_type === 'area'" class="h-full">
      <Card
        :data-source="dataSource"
        :graph="graph_clone"
        :page-reference="pageReference"
        :name="graph_clone.name"
        v-bind="common_chart_props">
        <template v-if="graph_data.length >= 1" #checkbox>
          <div class="flex justify-between mt-2 ml-6">
            <input
              v-model="checked"
              type="checkbox"
              class="form-checkbox text-light-brand-blue dark:text-dark-brand-blue checked:bg-light-brand-blue dark:checked:bg-dark-brand-blue bg-light-box-background dark:bg-dark-box-background border-[2px] focus:ring-0 ring-dark/0 border-common-grey w-5 rounded h-5 transition ease-in-out duration-side-menu-transition-duration">
            <div class="text-[13px] ml-4 pb-4 text-light-body-text dark:text-dark-body-text">
              {{ $t("Toggle Legend") }}
            </div>
          </div>
        </template>

        <AreaChart
          v-if="graph_data.length >= 1"
          :height="itemLayoutHeight / 6"
          :color1="graph_color"
          :chartid="chartId"
          :chartdata="graph_data"
          v-bind="common_chart_props" />
        <div v-else class="pl-4 flex items-center justify-center min-h-[300px] dark:text-dark-body-text">
          {{ $t("No data to display") }}
        </div>
      </Card>
    </div>

    <!-- Spline Area Chart Type -->
    <div v-else-if="graph_clone.graph_type === 'spline_area'" class="h-full">
      <Card
        :data-source="dataSource"
        :graph="graph_clone"
        :page-reference="pageReference"
        :name="graph_clone.name"
        v-bind="common_chart_props">
        <template v-if="graph_data.length >= 1" #checkbox>
          <div class="flex justify-between mt-2 ml-6">
            <input
              v-model="checked"
              type="checkbox"
              class="form-checkbox text-light-brand-blue dark:text-dark-brand-blue checked:bg-light-brand-blue dark:checked:bg-dark-brand-blue bg-light-box-background dark:bg-dark-box-background border-[2px] focus:ring-0 ring-dark/0 border-common-grey w-5 rounded h-5 transition ease-in-out duration-side-menu-transition-duration">
            <div class="text-[13px] ml-4 pb-4 text-light-body-text dark:text-dark-body-text">
              {{ $t("Toggle Legend") }}
            </div>
          </div>
        </template>

        <SplineAreaChart
          v-if="graph_data.length >= 1"
          :height="itemLayoutHeight / 6"
          :color1="graph_color"
          :chartid="chartId"
          :chartdata="graph_data"
          v-bind="common_chart_props" />
        <div v-else class="pl-4 flex items-center justify-center min-h-[300px] dark:text-dark-body-text">
          {{ $t("No data to display") }}
        </div>
      </Card>
    </div>

    <!-- Negative Area Chart Type -->
    <div v-else-if="graph_clone.graph_type === 'negative_area'" class="h-full">
      <Card
        :data-source="dataSource"
        :graph="graph_clone"
        :page-reference="pageReference"
        :name="graph_clone.name"
        v-bind="common_chart_props">
        <template v-if="graph_data.length >= 1" #checkbox>
          <div class="flex justify-between mt-2 ml-6">
            <input
              v-model="checked"
              type="checkbox"
              class="form-checkbox text-light-brand-blue dark:text-dark-brand-blue checked:bg-light-brand-blue dark:checked:bg-dark-brand-blue bg-light-box-background dark:bg-dark-box-background border-[2px] focus:ring-0 ring-dark/0 border-common-grey w-5 rounded h-5 transition ease-in-out duration-side-menu-transition-duration">
            <div class="text-[13px] ml-4 pb-4 text-light-body-text dark:text-dark-body-text">
              {{ $t("Toggle Legend") }}
            </div>
          </div>
        </template>

        <NegativeAreaChart
          v-if="graph_data.length >= 1"
          :height="itemLayoutHeight / 6"
          :color1="graph_color"
          :chartid="chartId"
          :chartdata="graph_data"
          v-bind="common_chart_props" />
        <div v-else class="pl-4 flex items-center justify-center min-h-[300px] dark:text-dark-body-text">
          {{ $t("No data to display") }}
        </div>
      </Card>
    </div>

    <!-- Polar Area Chart Type -->
    <div v-else-if="graph_clone.graph_type === 'polarArea'" class="h-full">
      <Card
        :data-source="dataSource"
        :graph="graph_clone"
        :page-reference="pageReference"
        :name="graph_clone.name"
        v-bind="common_chart_props">
        <template v-if="graph_data.length >= 1" #checkbox>
          <div class="flex justify-between mt-2 ml-6">
            <input
              v-model="checked"
              type="checkbox"
              class="form-checkbox text-light-brand-blue dark:text-dark-brand-blue checked:bg-light-brand-blue dark:checked:bg-dark-brand-blue bg-light-box-background dark:bg-dark-box-background border-[2px] focus:ring-0 ring-dark/0 border-common-grey w-5 rounded h-5 transition ease-in-out duration-side-menu-transition-duration">
            <div class="text-[13px] ml-4 pb-4 text-light-body-text dark:text-dark-body-text">
              {{ $t("Toggle Legend") }}
            </div>
          </div>
        </template>

        <PolarChart
          v-if="graph_data.length >= 1"
          :chartid="chartId"
          :chartdata="graph_data"
          :colors="graph_series_color"
          :labels="graph_labels"
          :height="itemLayoutHeight"
          v-bind="common_chart_props" />
        <div v-else class="pl-4 flex items-center justify-center min-h-[300px] dark:text-dark-body-text">
          {{ $t("No data to display") }}
        </div>
      </Card>
    </div>

    <!-- Polar Monochrome Chart Type -->
    <div v-else-if="graph_clone.graph_type === 'polarMonochrome'" class="h-full">
      <Card
        :data-source="dataSource"
        :graph="graph_clone"
        :page-reference="pageReference"
        :name="graph_clone.name"
        v-bind="common_chart_props">
        <template v-if="graph_data.length >= 1" #checkbox>
          <div class="flex justify-between mt-2 ml-6">
            <input
              v-model="checked"
              type="checkbox"
              class="form-checkbox text-light-brand-blue dark:text-dark-brand-blue checked:bg-light-brand-blue dark:checked:bg-dark-brand-blue bg-light-box-background dark:bg-dark-box-background border-[2px] focus:ring-0 ring-dark/0 border-common-grey w-5 rounded h-5 transition ease-in-out duration-side-menu-transition-duration">
            <div class="text-[13px] ml-4 pb-4 text-light-body-text dark:text-dark-body-text">
              {{ $t("Toggle Legend") }}
            </div>
          </div>
        </template>

        <PolarMonochromeChart
          v-if="graph_data.length >= 1"
          :chartid="chartId"
          :chartdata="graph_data"
          :colors="graph_series_color"
          :labels="graph_labels"
          :height="itemLayoutHeight"
          v-bind="common_chart_props" />
        <div v-else class="pl-4 flex items-center justify-center min-h-[300px] dark:text-dark-body-text">
          {{ $t("No data to display") }}
        </div>
      </Card>
    </div>

    <!-- Line Chart Type -->
    <div v-else-if="graph_clone.graph_type === 'line'" class="h-full">
      <Card
        :data-source="dataSource"
        :graph="graph_clone"
        :page-reference="pageReference"
        :name="graph_clone.name"
        v-bind="common_chart_props">
        <template v-if="graph_data.length >= 1" #checkbox>
          <div class="flex justify-between mt-2 ml-6">
            <input
              v-model="checked"
              type="checkbox"
              class="form-checkbox text-light-brand-blue dark:text-dark-brand-blue checked:bg-light-brand-blue dark:checked:bg-dark-brand-blue bg-light-box-background dark:bg-dark-box-background border-[2px] focus:ring-0 ring-dark/0 border-common-grey w-5 rounded h-5 transition ease-in-out duration-side-menu-transition-duration">
            <div class="text-[13px] ml-4 pb-4 text-light-body-text dark:text-dark-body-text">
              {{ $t("Toggle Legend") }}
            </div>
          </div>
        </template>

        <LineChart
          v-if="graph_data.length >= 1"
          :height="itemLayoutHeight / 6"
          :color1="graph_color"
          :chartid="chartId"
          :chartdata="graph_data"
          v-bind="common_chart_props" />
        <div v-else class="pl-4 flex items-center justify-center min-h-[300px] dark:text-dark-body-text">
          {{ $t("No data to display") }}
        </div>
      </Card>
    </div>

    <!-- Brush Chart Type -->
    <div v-else-if="graph_clone.graph_type === 'brush'" class="h-full">
      <Card
        :data-source="dataSource"
        :graph="graph_clone"
        :page-reference="pageReference"
        :name="graph_clone.name"
        v-bind="common_chart_props">
        <template v-if="graph_data.length >= 1" #checkbox>
          <div class="flex justify-between mt-2 ml-6">
            <input
              v-model="checked"
              type="checkbox"
              class="form-checkbox text-light-brand-blue dark:text-dark-brand-blue checked:bg-light-brand-blue dark:checked:bg-dark-brand-blue bg-light-box-background dark:bg-dark-box-background border-[2px] focus:ring-0 ring-dark/0 border-common-grey w-5 rounded h-5 transition ease-in-out duration-side-menu-transition-duration">
            <div class="text-[13px] ml-4 pb-4 text-light-body-text dark:text-dark-body-text">
              {{ $t("Toggle Legend") }}
            </div>
          </div>
        </template>

        <BrushChart
          v-if="graph_data.length >= 1"
          :height="itemLayoutHeight / 6"
          :color1="graph_color"
          :chartid="chartId"
          :chartdata="graph_data"
          v-bind="common_chart_props" />
        <div v-else class="pl-4 flex items-center justify-center min-h-[300px] dark:text-dark-body-text">
          {{ $t("No data to display") }}
        </div>
      </Card>
    </div>

    <!-- Dashed Line Chart Type -->
    <div v-else-if="graph_clone.graph_type === 'dashed_line'" class="h-full">
      <Card
        :data-source="dataSource"
        :graph="graph_clone"
        :page-reference="pageReference"
        :name="graph_clone.name"
        v-bind="common_chart_props">
        <template v-if="graph_data.length >= 1" #checkbox>
          <div class="flex justify-between mt-2 ml-6">
            <input
              v-model="checked"
              type="checkbox"
              class="form-checkbox text-light-brand-blue dark:text-dark-brand-blue checked:bg-light-brand-blue dark:checked:bg-dark-brand-blue bg-light-box-background dark:bg-dark-box-background border-[2px] focus:ring-0 ring-dark/0 border-common-grey w-5 rounded h-5 transition ease-in-out duration-side-menu-transition-duration">
            <div class="text-[13px] ml-4 pb-4 text-light-body-text dark:text-dark-body-text">
              {{ $t("Toggle Legend") }}
            </div>
          </div>
        </template>

        <DashedLineChart
          v-if="graph_data.length >= 1"
          :height="itemLayoutHeight / 6"
          :color1="graph_color"
          :chartid="chartId"
          :chartdata="graph_data"
          v-bind="common_chart_props" />
        <div v-else class="pl-4 flex items-center justify-center min-h-[300px] dark:text-dark-body-text">
          {{ $t("No data to display") }}
        </div>
      </Card>
    </div>

    <!-- Mixed Charts Type -->
    <div v-else-if="graph_clone.graph_type === 'mixed_charts'" class="h-full">
      <Card
        :data-source="dataSource"
        :graph="graph_clone"
        :page-reference="pageReference"
        :name="graph_clone.name"
        v-bind="common_chart_props">
        <template v-if="graph_data.length >= 1" #checkbox>
          <div class="flex justify-between mt-2 ml-6">
            <input
              v-model="checked"
              type="checkbox"
              class="form-checkbox text-light-brand-blue dark:text-dark-brand-blue checked:bg-light-brand-blue dark:checked:bg-dark-brand-blue bg-light-box-background dark:bg-dark-box-background border-[2px] focus:ring-0 ring-dark/0 border-common-grey w-5 rounded h-5 transition ease-in-out duration-side-menu-transition-duration">
            <div class="text-[13px] ml-4 pb-4 text-light-body-text dark:text-dark-body-text">
              {{ $t("Toggle Legend") }}
            </div>
          </div>
        </template>

        <MixedCharts
          v-if="graph_data.length >= 1"
          :height="itemLayoutHeight / 6"
          :color1="graph_color"
          :chartid="chartId"
          :chartdata="graph_data"
          v-bind="common_chart_props" />
        <div v-else class="pl-4 flex items-center justify-center min-h-[300px] dark:text-dark-body-text">
          {{ $t("No data to display") }}
        </div>
      </Card>
    </div>

    <!-- Pyramid Charts Type -->
    <div v-else-if="graph_clone.graph_type === 'pyramid_chart'" class="h-full">
      <Card
        :data-source="dataSource"
        :graph="graph_clone"
        :page-reference="pageReference"
        :name="graph_clone.name"
        v-bind="common_chart_props">
        <template v-if="graph_data.length >= 1" #checkbox>
          <div class="flex justify-between mt-2 ml-6">
            <input
              v-model="checked"
              :style="{ backgroundColor: backgroundColor }"
              type="checkbox"
              class="form-checkbox text-light-brand-blue dark:text-dark-brand-blue checked:bg-light-brand-blue dark:checked:bg-dark-brand-blue bg-light-box-background dark:bg-dark-box-background border-[2px] focus:ring-0 ring-dark/0 border-common-grey w-5 rounded h-5 transition ease-in-out duration-side-menu-transition-duration">
            <div class="text-[13px] ml-4 pb-4 text-light-body-text dark:text-dark-body-text">
              {{ $t("Toggle Legend") }}
            </div>
          </div>
        </template>
        <PyramidChart
          v-if="graph_data.length >= 1"
          :height="itemLayoutHeight / 6"
          :chartid="chartId"
          :chartdata="graph_data"
          :labels="graph_labels"
          v-bind="common_chart_props" />
        <div v-else class="pl-4 flex items-center justify-center min-h-[300px] dark:text-dark-body-text">
          {{ $t("No data to display") }}
        </div>
      </Card>
    </div>

    <!-- Funnel Charts Type -->
    <div v-else-if="graph_clone.graph_type === 'funnel_chart'" class="h-full">
      <Card
        :data-source="dataSource"
        :graph="graph_clone"
        :page-reference="pageReference"
        :name="graph_clone.name"
        v-bind="common_chart_props">
        <template v-if="graph_data.length >= 1" #checkbox>
          <div class="flex justify-between mt-2 ml-6">
            <input
              v-model="checked"
              :style="{ backgroundColor: backgroundColor }"
              type="checkbox"
              class="form-checkbox text-light-brand-blue dark:text-dark-brand-blue checked:bg-light-brand-blue dark:checked:bg-dark-brand-blue bg-light-box-background dark:bg-dark-box-background border-[2px] focus:ring-0 ring-dark/0 border-common-grey w-5 rounded h-5 transition ease-in-out duration-side-menu-transition-duration">
            <div class="text-[13px] ml-4 pb-4 text-light-body-text dark:text-dark-body-text">
              {{ $t("Toggle Legend") }}
            </div>
          </div>
        </template>
        <FunnelChart
          v-if="graph_data.length >= 1"
          :height="itemLayoutHeight / 6"
          :chartid="chartId"
          :chartdata="graph_data"
          :labels="graph_labels"
          v-bind="common_chart_props" />
        <div v-else class="pl-4 flex items-center justify-center min-h-[300px] dark:text-dark-body-text">
          {{ $t("No data to display") }}
        </div>
      </Card>
    </div>

    <!-- Stepline Charts Type -->
    <div v-else-if="graph_clone.graph_type === 'stepline_chart'" class="h-full">
      <Card
        :data-source="dataSource"
        :graph="graph_clone"
        :page-reference="pageReference"
        :name="graph_clone.name"
        v-bind="common_chart_props">
        <template v-if="graph_data.length >= 1" #checkbox>
          <div class="flex justify-between mt-2 ml-6">
            <input
              v-model="checked"
              :style="{ backgroundColor: backgroundColor }"
              type="checkbox"
              class="form-checkbox text-light-brand-blue dark:text-dark-brand-blue checked:bg-light-brand-blue dark:checked:bg-dark-brand-blue bg-light-box-background dark:bg-dark-box-background border-[2px] focus:ring-0 ring-dark/0 border-common-grey w-5 rounded h-5 transition ease-in-out duration-side-menu-transition-duration">
            <div class="text-[13px] ml-4 pb-4 text-light-body-text dark:text-dark-body-text">
              {{ $t("Toggle Legend") }}
            </div>
          </div>
        </template>
        <SteplineChart
          v-if="graph_data.length >= 1"
          :height="itemLayoutHeight / 6"
          :chartid="chartId"
          :chartdata="graph_data"
          :labels="graph_labels"
          v-bind="common_chart_props" />
        <div v-else class="pl-4 flex items-center justify-center min-h-[300px] dark:text-dark-body-text">
          {{ $t("No data to display") }}
        </div>
      </Card>
    </div>

    <!-- Gradient Charts Type -->
    <div v-else-if="graph_clone.graph_type === 'gradient_chart'" class="h-full">
      <Card
        :data-source="dataSource"
        :graph="graph_clone"
        :page-reference="pageReference"
        :name="graph_clone.name"
        v-bind="common_chart_props">
        <template v-if="graph_data.length >= 1" #checkbox>
          <div class="flex justify-between mt-2 ml-6">
            <input
              v-model="checked"
              :style="{ backgroundColor: backgroundColor }"
              type="checkbox"
              class="form-checkbox text-light-brand-blue dark:text-dark-brand-blue checked:bg-light-brand-blue dark:checked:bg-dark-brand-blue bg-light-box-background dark:bg-dark-box-background border-[2px] focus:ring-0 ring-dark/0 border-common-grey w-5 rounded h-5 transition ease-in-out duration-side-menu-transition-duration">
            <div class="text-[13px] ml-4 pb-4 text-light-body-text dark:text-dark-body-text">
              {{ $t("Toggle Legend") }}
            </div>
          </div>
        </template>
        <GradientChart
          v-if="graph_data.length >= 1"
          :height="itemLayoutHeight / 6"
          :chartid="chartId"
          :chartdata="graph_data"
          :labels="graph_labels"
          v-bind="common_chart_props" />
        <div v-else class="pl-4 flex items-center justify-center min-h-[300px] dark:text-dark-body-text">
          {{ $t("No data to display") }}
        </div>
      </Card>
    </div>

    <!-- Radial Bar Chart Type -->
    <div v-else-if="graph_clone.graph_type === 'radialBar'" class="h-full">
      <Card
        :data-source="dataSource"
        :graph="graph_clone"
        :page-reference="pageReference"
        :name="graph_clone.name"
        v-bind="common_chart_props">
        <template v-if="graph_data.length >= 1" #checkbox>
          <div class="flex justify-between mt-2 ml-6">
            <input
              v-model="checked"
              type="checkbox"
              class="form-checkbox text-light-brand-blue dark:text-dark-brand-blue checked:bg-light-brand-blue dark:checked:bg-dark-brand-blue bg-light-box-background dark:bg-dark-box-background border-[2px] focus:ring-0 ring-dark/0 border-common-grey w-5 rounded h-5 transition ease-in-out duration-side-menu-transition-duration">
            <div class="text-[13px] ml-4 pb-4 text-light-body-text dark:text-dark-body-text">
              {{ $t("Toggle Legend") }}
            </div>
          </div>
        </template>

        <RadialBarChart
          v-if="graph_data.length >= 1"
          :chartid="chartId"
          :chartdata="graph_data"
          :colors="graph_series_color"
          :labels="graph_labels"
          :height="itemLayoutHeight"
          v-bind="common_chart_props" />
        <div v-else class="pl-4 flex items-center justify-center min-h-[300px] dark:text-dark-body-text">
          {{ $t("No data to display") }}
        </div>
      </Card>
    </div>

    <!-- Fallback for Other Chart Types -->
    <div v-else class="h-full">
      <Card
        :data-source="dataSource"
        :graph="graph_clone"
        :page-reference="pageReference"
        :name="graph_clone.name"
        v-bind="common_chart_props">
        <template v-if="graph_data.length >= 1" #checkbox>
          <div class="flex justify-between mt-2 ml-6">
            <input
              v-model="checked"
              type="checkbox"
              class="form-checkbox text-light-brand-blue dark:text-dark-brand-blue checked:bg-light-brand-blue dark:checked:bg-dark-brand-blue bg-light-box-background dark:bg-dark-box-background border-[2px] focus:ring-0 ring-dark/0 border-common-grey w-5 rounded h-5 transition ease-in-out duration-side-menu-transition-duration">
            <div class="text-[13px] ml-4 pb-4 text-light-body-text dark:text-dark-body-text">
              {{ $t("Toggle Legend") }}
            </div>
          </div>
        </template>

        <XChart
          v-if="graph_data.length >= 1"
          :type="graph_clone.graph_type"
          :chartid="chartId"
          :chartdata="graph_data"
          v-bind="common_chart_props" />
        <div v-else class="pl-4 flex items-center justify-center min-h-[300px] dark:text-dark-body-text">
          {{ $t("No data to display") }}
        </div>
      </Card>
    </div>
  </div>
</template>

<script>
import { useLayoutItemSharedLogic } from "@/components/shared/pages/useLayoutItemSharedLogic.js"
import XChart from "@/components/shared/XChart.vue"
import Card from "@/components/shared/Card.vue"
import PieChart from "@/components/shared/PieChart.vue"
import DonutChart from "@/components/shared/DonutChart.vue"
import BarChart from "@/components/shared/BarChart.vue"
import StackedChart from "@/components/shared/StackedChart.vue"
import PatternedChart from "@/components/shared/PatternedChart.vue"
import PyramidChart from "@/components/shared/PyramidChart.vue"
import FunnelChart from "@/components/shared/FunnelChart.vue"
import SteplineChart from "@/components/shared/SteplineChart.vue"
import GradientChart from "@/components/shared/GradientChart.vue"
import TableChart from "@/components/shared/TableChart.vue"
import PolarChart from "@/components/shared/PolarChart.vue"
import PolarMonochromeChart from "@/components/shared/PolarMonochromeChart.vue"
import RadialBarChart from "@/components/shared/RadialBarChart.vue"
import LineChart from "@/components/shared/LineChart.vue"
import BrushChart from "@/components/shared/BrushChart.vue"
import DashedLineChart from "@/components/shared/DashedLineChart.vue"
import AreaChart from "@/components/shared/AreaChart.vue"
import SplineAreaChart from "@/components/shared/SplineAreaChart.vue"
import NegativeAreaChart from "@/components/shared/NegativeAreaChart.vue"
import MixedCharts from "@/components/shared/MixedCharts.vue"
import { utils } from "@/store/helpers"

import { ALL_EMITTERS } from "@/store/constants/all_emitters"

export default {
  components: {
    XChart,
    Card,
    PieChart,
    DonutChart,
    BarChart,
    StackedChart,
    PatternedChart,
    PyramidChart,
    FunnelChart,
    SteplineChart,
    GradientChart,
    TableChart,
    PolarChart,
    PolarMonochromeChart,
    RadialBarChart,
    LineChart,
    BrushChart,
    DashedLineChart,
    AreaChart,
    SplineAreaChart,
    NegativeAreaChart,
    MixedCharts
  },
  props: {
    backgroundColor: null,
    textColor: null,
    dataSource: null,
    graph: {
      type: String,
      required: true
    },
    linkedRecord: {
      type: String,
      required: false
    },
    pageReference: {
      type: String,
      required: true
    },
    itemLayoutHeight: {
      type: Number,
      default: null
    }
  },
  data() {
    return {
      loading: false,
      record_error: false,
      component_record: null,
      chartId: utils.generateRandomKey(),
      checked: true,
      show_values: true,
      show_data_labels: false,
      show_zoom: true,
      graph_clone: null
    }
  },
  computed: {
    common_chart_props() {
      return {
        textColor: this.textColor,
        backgroundColor: this.backgroundColor,
        showDataLabels: this.show_data_labels,
        graphObj: this.graph_clone,
        axis: this.graph_clone.axis,
        hasLegend: this.checked
      }
    },
    graph_data() {
      /*if (this.graph_clone?.datasets?.datasets.length) {
        this.graph_clone.series.map((s, index) => {
          if (s.aggregation_method) {
            this.graph_clone.datasets.datasets[index].label = `${this.graph_clone.datasets.datasets[index].label} (${s.aggregation_method})`
          }
        })
      }*/
      return this.graph_clone?.datasets?.datasets.length ? this.graph_clone?.datasets?.datasets : []
    },
    graph_series_color() {
      return this.graph_clone?.datasets?.datasets.length ? this.graph_clone?.datasets?.datasets[0].backgroundColor : ""
    },
    graph_color() {
      return this.graph_clone?.datasets?.datasets.length ? this.graph_clone?.datasets?.datasets[0].backgroundColor[0] : ""
    },
    graph_labels() {
      let labels = []
      this.graph_clone?.datasets.labels.map((x) => {
        x || x == 0 ? labels.push(x) : labels.push("")
      })
      return labels
    }
  },
  created() {
    const { loading, record_error, component_record } = useLayoutItemSharedLogic(
      this.$props,
      this.postGetComponentRecord,
      this.registerListeners,
      this.unregisterListeners
    )
    this.loading = loading
    this.record_error = record_error
    this.component_record = component_record

    this.graph_clone = utils.clone(this.$store.state.data.graphs.find((g) => g?.id == this.graph))
    if (this.graph_clone?.graph_options?.show_labels == false) {
      this.checked = false
    } else {
      this.checked = true
    }
    1
    if (this.graph_clone?.graph_options?.show_values == false) {
      this.show_values = false
    } else {
      this.show_values = true
    }
    if (!this.graph_clone?.graph_options?.show_data_labels) {
      this.show_data_labels = false
    } else {
      this.show_data_labels = true
    }
    if (this.graph_clone?.graph_options?.show_zoom == false) {
      this.show_zoom = false
    } else {
      this.show_zoom = true
    }
  },
  mounted() {
    if (this.dataSource != "this_record" && this.dataSource != "another_record") {
      this.getGraphDataSet()
    }
  },
  methods: {
    postGetComponentRecord() {
      this.getGraphDataSet()
    },
    registerListeners() {
      this.$emitter.on(ALL_EMITTERS.GRAPH_UPDATED, (graph) => {
        if (graph?.id == this.graph_clone?.id) {
          this.getGraphDataSet()
        }
      })
    },
    unregisterListeners() {
      this.$emitter.off(ALL_EMITTERS.GRAPH_UPDATED)
    },
    getGraphDataSet() {
      const params = {}

      if (this.$store.state.data.groups.find((g) => g?.id == this.dataSource)) {
        params["group"] = this.dataSource
      }

      if (this.dataSource == "another_record") {
        params["record"] = this.linkedRecord
      } else if (this.dataSource == "this_record") {
        params["record"] = this.component_record?.id
      }
      // Case 1
      // level 1: Company
      //       level 2: Company Child Graph
      //           in this level case the This record is the actually the Parent Id (ie the filter is parent_id = level 1 company id)
      // Case 2
      // level 1: Company
      //           level 2: Company Graph
      //           in this case the this record is the company id (ie the filter is id=level 1 company id)

      // locate if the graph is a child graph
      // if the this.graph.type != company then it is a child graph
      params["graph_page"] = this.$route.params.object_type
      let graph_id = this.graph_clone?.id || this.graph?.id || this.graph
      this.$store.dispatch("data/getGraph", { graph_id: graph_id, params: params }).then((data) => {
        this.graph_clone = data.data
        this.checked = this.graph_clone.graph_options?.show_labels == false ? false : true
        this.show_values = this.graph_clone.graph_options?.show_values == false ? false : true
        this.show_data_labels = !this.graph_clone.graph_options?.show_data_labels ? false : true
        this.show_zoom = this.graph_clone.graph_options?.show_zoom == false ? false : true
      })
    }
  }
}
</script>
